<section class="section support-section">
  <div class="container">
    <div class="support-card">
      <div class="support-content">
        <div class="support-text">
          <h2>Support the Project</h2>
          <p class="lead">
            Keep is free and always will be. If you find it useful, consider buying me a coffee!
          </p>
          <p class="description">
            Your support helps me dedicate more time to adding features, fixing bugs, and keeping
            this project maintained for everyone. Every coffee counts! ☕
          </p>
          <div class="support-buttons">
            <a href="https://www.buymeacoffee.com/yourusername" target="_blank" rel="noopener noreferrer" class="btn btn-coffee">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.216 6.415l-.132-.666c-.119-.598-.388-1.163-1.001-1.379-.197-.069-.42-.098-.57-.241-.152-.143-.196-.366-.231-.572-.065-.378-.125-.756-.192-1.133-.057-.325-.102-.69-.25-.987-.195-.4-.597-.634-.996-.788a5.723 5.723 0 00-.626-.194c-1-.263-2.05-.36-3.077-.416a25.834 25.834 0 00-3.7.062c-.915.083-1.88.184-2.75.5-.318.116-.646.256-.888.501-.297.302-.393.77-.177 1.146.154.267.415.456.692.58.36.162.737.284 1.123.366 1.075.238 2.189.331 3.287.37 1.218.05 2.437.01 3.65-.118.299-.033.598-.073.896-.119.352-.054.578-.513.474-.834-.124-.383-.457-.531-.834-.473-.466.074-.96.108-1.382.146-1.177.08-2.358.082-3.536.006a22.228 22.228 0 01-1.157-.107c-.086-.01-.18-.025-.258-.036-.243-.036-.484-.08-.724-.13-.111-.027-.111-.185 0-.212h.005c.277-.06.557-.108.838-.147h.002c.131-.009.263-.032.394-.048a25.076 25.076 0 013.426-.12c.674.019 1.347.067 2.017.144l.228.031c.267.04.533.088.798.145.392.085.895.113 1.07.542.055.137.08.288.111.431l.319 1.484a.237.237 0 01-.199.284h-.003c-.037.006-.075.01-.112.015a36.704 36.704 0 01-4.743.295 37.059 37.059 0 01-4.699-.304c-.14-.017-.293-.042-.417-.06-.326-.048-.649-.108-.973-.161-.393-.065-.768-.032-1.123.161-.29.16-.527.404-.675.701-.154.316-.198.663-.207 1.015-.02.857-.025 1.714-.035 2.572-.01.987-.01 1.975-.012 2.963l-.002.95c0 .125-.01.246-.01.371 0 .497.026.996.058 1.493.037.564.093 1.127.195 1.682.215 1.163.788 2.144 1.711 2.839.494.372 1.05.638 1.627.85.918.337 1.881.535 2.86.636.959.099 1.924.11 2.887.078 1.234-.041 2.466-.179 3.657-.56.975-.311 1.9-.737 2.698-1.382.853-.689 1.417-1.59 1.643-2.687.094-.46.149-.926.175-1.394.032-.579.046-1.16.043-1.74a58.293 58.293 0 00-.078-4.052c-.025-.332-.058-.665-.098-.996-.036-.3-.08-.599-.13-.897-.11-.627-.267-1.242-.524-1.827-.114-.261-.27-.503-.463-.718z"/>
              </svg>
              <span>Buy Me a Coffee</span>
            </a>
          </div>
        </div>
        <div class="support-visual">
          <div class="coffee-cup">☕</div>
          <p class="support-note">100% free, 0% ads<br/>Your support keeps it that way!</p>
        </div>
      </div>
    </div>
  </div>
</section>

<style>
  .support-section {
    background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  }

  .support-card {
    background: #ffffff;
    border: 2px solid var(--color-border);
    border-radius: var(--radius-xl);
    padding: var(--spacing-2xl);
    box-shadow: var(--shadow-md);
  }

  .support-content {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: var(--spacing-2xl);
    align-items: center;
  }

  .support-text h2 {
    font-size: var(--font-size-2xl);
    margin-bottom: var(--spacing-sm);
    color: var(--color-text-primary);
  }

  .lead {
    font-size: var(--font-size-lg);
    color: var(--color-text-secondary);
    margin-bottom: var(--spacing-md);
  }

  .description {
    color: var(--color-text-secondary);
    line-height: var(--line-height-normal);
    font-size: var(--font-size-sm);
    margin-bottom: var(--spacing-xl);
  }

  .support-buttons {
    display: flex;
    gap: var(--spacing-md);
    flex-wrap: wrap;
  }

  .btn-coffee {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    color: white;
    border: none;
  }

  .btn-coffee:hover {
    background: linear-gradient(135deg, #059669 0%, #047857 100%);
    color: white;
    transform: translateY(-2px);
  }

  .support-visual {
    text-align: center;
  }

  .coffee-cup {
    font-size: 96px;
    line-height: 1;
    margin-bottom: var(--spacing-md);
    animation: steam 2s ease-in-out infinite;
  }

  .support-note {
    font-size: var(--font-size-xs);
    color: var(--color-text-secondary);
    font-weight: var(--font-weight-medium);
    margin: 0;
  }

  @keyframes steam {
    0%, 100% {
      transform: translateY(0) scale(1);
    }
    50% {
      transform: translateY(-5px) scale(1.05);
    }
  }

  @media (max-width: 968px) {
    .support-card {
      padding: var(--spacing-xl);
    }

    .support-content {
      grid-template-columns: 1fr;
      gap: var(--spacing-xl);
    }

    .support-text h2 {
      font-size: var(--font-size-xl);
    }

    .coffee-cup {
      font-size: 72px;
    }

    .support-buttons {
      flex-direction: column;
    }

    .support-buttons .btn {
      width: 100%;
    }
  }
</style>
